import { render, staticRenderFns } from "./OrderDetailItem.vue?vue&type=template&id=52319091&scoped=true&"
import script from "./OrderDetailItem.vue?vue&type=script&lang=js&"
export * from "./OrderDetailItem.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetailItem.vue?vue&type=style&index=0&id=52319091&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52319091",
  null
  
)

component.options.__file = "OrderDetailItem.vue"
export default component.exports